export default __webpack_public_path__ + "static/media/riskratingLightIcon.12d94350.svg";